import {Routes} from '@angular/router';
import {AdminSectionComponent} from '../containers/admin.component';
import {LoggedInGuard} from '../guards/logged-in';
import {ChangePasswordGuard} from '../guards/change-password';
import {AdminGuard} from '../guards/admin';
import {AdminDashboardPageComponent} from '../containers/admin-dashboard';
import {ErrorLogPageComponent} from '../containers/error-log';
import {UserSectionComponent} from '../containers/user';
import {UserRoutes} from './user';
import {ListComponent} from '../containers/list';
import {SuperAdminGuard} from '../guards/super-admin';
import {ListRoutes} from './list';
import {SettingSectionComponent} from '../containers/setting';
import {SettingRoutes} from './setting';
import {AdminAccessRequestsPageComponent} from '../containers/admin-access-requests';
import {ContactSectionComponent} from '../containers/contact';
import {ContactRoutes} from './contact';
import {RegisterPageComponent} from '../containers/register';
import {LoginPageComponent} from '../containers/login';
import {ForgotPasswordPageComponent} from '../containers/forgot-password';
import {ChangePasswordPageComponent} from '../containers/change-password';
import {ContactEditorPageComponent} from '../containers/contact-editor';
import { UserAgreementContainerComponent } from 'app/modules/core/containers/user-agreement';
import { UserAgreementGuard } from 'app/modules/core/guards/user-agreement';



export const CoreRoutes: Routes = [
  { path: 'admin',
    component: AdminSectionComponent,
    canActivate: [LoggedInGuard, ChangePasswordGuard, AdminGuard, UserAgreementGuard],
    data: {
      breadcrumb: 'Admin'
    },
    children: [
      {
        path: '',
        component: AdminDashboardPageComponent,
        canActivate: [LoggedInGuard, ChangePasswordGuard, AdminGuard],
        data: {
          breadcrumb: 'Dashboard'
        }
      },
      {
        path: 'logs',
        component: ErrorLogPageComponent,
        canActivate: [LoggedInGuard, ChangePasswordGuard, SuperAdminGuard],
        data: {
          breadcrumb: 'Logs'
        }
      },
      {
        path: 'users',
        component: UserSectionComponent,
        canActivate: [LoggedInGuard, ChangePasswordGuard, AdminGuard],
        data: {
          breadcrumb: 'Users'
        },
        children: UserRoutes
      },
      {
        path: 'lists',
        component: ListComponent,
        canActivate: [LoggedInGuard, ChangePasswordGuard, SuperAdminGuard],
        data: {
          breadcrumb: 'List Management'
        },
        children: ListRoutes
      },
      {
        path: 'settings',
        component: SettingSectionComponent,
        canActivate: [LoggedInGuard, ChangePasswordGuard, SuperAdminGuard],
        data: {
          breadcrumb: 'Setting Management'
        },
        children: SettingRoutes
      },
      {
        path: 'accessrequests',
        component: AdminAccessRequestsPageComponent,
        canActivate: [LoggedInGuard, ChangePasswordGuard, AdminGuard],
        data: {
          breadcrumb: 'Access Requests'
        }
      },
      {
        path: 'contacts',
        component: ContactSectionComponent,
        canActivate: [LoggedInGuard, ChangePasswordGuard, SuperAdminGuard],
        data: {
          breadcrumb: 'Contacts'
        },
        children: ContactRoutes
      }
    ]
  },
  { path: 'register',
    component: RegisterPageComponent,
    data: {
      breadcrumb: 'Register'
    }
  },
  { path: 'login',
    component: LoginPageComponent,
    data: {
      breadcrumb: 'Login'
    }
  },
  { path: 'forgotpassword',
    component: ForgotPasswordPageComponent,
    data: {
      breadcrumb: 'Forgot Password'
    }
  },
  { path: 'changepassword',
    component: ChangePasswordPageComponent,
    canActivate: [LoggedInGuard, UserAgreementGuard],
    data: {
      breadcrumb: 'Change Password'
    }
  },
  { path: 'agreement',
    component: UserAgreementContainerComponent,
    canActivate: [LoggedInGuard],
    data: {
      breadcrumb: 'User Agreement'
    }
  },
  { path: 'userprofile',
    component: ContactEditorPageComponent,
    canActivate: [LoggedInGuard, ChangePasswordGuard, UserAgreementGuard],
    data: {
      breadcrumb: 'User Profile'
    }
  }
];



// WEBPACK FOOTER //
// C:/Users/jstan/Projects/usda-document-client/src/app/modules/core/routes/core.ts